import React from 'react';
import { FaLaptop, FaTimes } from 'react-icons/fa';

export default function CoworkingOfferBanner() {
  const [hidden, setHidden] = React.useState(() => {
    try {
      return sessionStorage.getItem('coworking_offer_dismissed') === '1';
    } catch {
      return false;
    }
  });

  if (hidden) return null;

  const dismiss = () => {
    try { sessionStorage.setItem('coworking_offer_dismissed', '1'); } catch {}
    setHidden(true);
  };

  return (
    <div style={{
      width: '100%',
      background: 'linear-gradient(90deg, #111827, #1f2937)',
      color: '#f9fafb',
      padding: '12px 16px',
      boxSizing: 'border-box',
      textAlign: 'center',
      position: 'relative',
      zIndex: 1,
      borderBottom: '1px solid rgba(255,255,255,0.1)'
    }}>
      <button
        aria-label="Dismiss co-working offer"
        onClick={dismiss}
        style={{
          position: 'absolute',
          right: 10,
          top: 8,
          background: 'transparent',
          border: 'none',
          color: '#e5e7eb',
          cursor: 'pointer'
        }}
      >
        <FaTimes />
      </button>
      <div style={{fontWeight: 800, letterSpacing: 0.3, fontSize: 16, display: 'inline-flex', alignItems: 'center', gap: 8, justifyContent: 'center'}}>
        <FaLaptop /> Stay & Work: 20% OFF Co‑working
      </div>
      <div style={{fontSize: 14, marginTop: 4, opacity: 0.95}}>
        Skyline guests get <b>20% off</b> at co‑working spaces. Show your booking at reception to redeem. Limited time. T&Cs apply.
      </div>
    </div>
  );
}
